import { SpeakUpFilterRow, SpeakUpFilterValue } from '../SpeakUpFilterPopover';

// Builds the FilterArray format that setSearchFilter/useTableColumns
// expects. CustomField.value is handled separately via customFieldSearch,
// so it's excluded here.
export const buildSearchValue = (
  rows: SpeakUpFilterRow[],
  value: SpeakUpFilterValue,
) =>
  rows?.flatMap((row) => {
    const col = row.column as keyof SpeakUpFilterValue;
    if (col === 'CustomField.value') return [];
    const val = col ? value[col] : undefined;
    if (!col || !val) return [];
    return [
      { label: col, value: col, __isNew__: false as const },
      { label: val, value: val, __isNew__: true as const },
    ];
  });

export const buildCustomFieldSearch = (
  value: SpeakUpFilterValue,
): { fieldId: string; value: string } | undefined => {
  const encoded = value['CustomField.value'];
  if (!encoded) return undefined;
  const separatorIndex = encoded.indexOf(':');
  if (separatorIndex === -1) return undefined;
  const fieldId = encoded.slice(0, separatorIndex);
  const searchText = encoded.slice(separatorIndex + 1);
  if (!fieldId || !searchText.trim()) return undefined;
  return { fieldId, value: searchText.trim() };
};
